export function expandingImage() {
  const image = document.querySelector('.wp-block-expanding-image img');

  if (!image) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('!scale-100');
          observer.unobserve(entry.target); // Unmount observer after class is added
        }
      });
    },
    { threshold: 0.2 },
  ); // Adjust threshold as needed

  observer.observe(image);
}
